import * as React from "react";
import Typography from "@mui/material/Typography";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import arrondir from "../libs/arrondir";

const PhraseCourbeRouge = ({
  step,
  texteEquilibreFinancier,
  texteNiveauVie,
  duree2022,
  duree2070,
}) => {
  if (step === 0) {
    return (
      <Typography>
        Comme le montre{" "}
        <Typography variant="span" color="primary" fontWeight="bold">
          <ShowChartIcon /> la courbe rouge
        </Typography>
        , votre réforme pourrait amener les caisses de retraite à être{" "}
        <Typography variant="span" color="primary" fontWeight="bold">
          {texteEquilibreFinancier}
        </Typography>
        .{" "}
      </Typography>
    );
  }
  if (step === 1) {
    return (
      <Typography>
        Comme le montre{" "}
        <Typography variant="span" color="primary" fontWeight="bold">
          <ShowChartIcon /> la courbe rouge
        </Typography>
        , votre réforme amènerait le niveau de vie des retraités par rapport au
        reste de la population active à un niveau{" "}
        <Typography variant="span" color="primary" fontWeight="bold">
          {texteNiveauVie}
        </Typography>{" "}
        qu'en l'absence de réforme, selon les projections du COR.{" "}
      </Typography>
    );
  }
  if (step === 2) {
    return (
      <Typography>
        Comme le montre{" "}
        <Typography variant="span" color="primary" fontWeight="bold">
          <ShowChartIcon /> la courbe rouge
        </Typography>
        , votre réforme aboutirait à ce que les retraités qui partiront à la
        retraite en 2070 passeront{" "}
        <Typography variant="span" color="primary" fontWeight="bold">
          {arrondir(duree2070, 1)} années à la retraite contre{" "}
          {arrondir(duree2022, 1)} années
        </Typography>{" "}
        pour les retraités partis en 2022.{" "}
      </Typography>
    );
  }
};

export default PhraseCourbeRouge;
